import { CURRENT_SETTINGS_VERSION, migrateSettings } from './migrate.ts';
import type { SettingsDocument } from './types.ts';

export function serializeSettings(document: SettingsDocument): string {
  return JSON.stringify({ ...document, version: CURRENT_SETTINGS_VERSION });
}

export function parseSettings(json: string): SettingsDocument | null {
  let parsed: unknown;

  try {
    parsed = JSON.parse(json);
  } catch {
    return null;
  }

  return migrateSettings(parsed);
}

export function isSettingsDocument(value: unknown): boolean {
  return migrateSettings(value) !== null;
}
